import React, { MouseEvent } from 'react';
import { Button, DangerText } from 'ui-toolkit';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRemove, faRightFromBracket } from '@fortawesome/pro-light-svg-icons';
import { Link } from 'react-router-dom';
import { ClientUrlFactory } from 'ui-toolkit/rest/ClientUrlFactory';
import { useGetSettingsQuery } from 'API/globalSearchBar/GlobalSearchBarSettings';
import { ColumnDefinitions, defaultColumns } from './ColumnDefinitions';
import { useGetUserType } from 'components/accessControl/hooks/useGetUserType';
import { ISearchOrderRequest } from '../../../ui-toolkit/orders/searchOrder/types/ISearchOrder';

export interface ISearchBarOrderTableProps {
  remove?: (fileNumber: string) => void;
  orders: ISearchOrderRequest[];
  dataTestId?: string;
}

export const SearchBarOrderTable: React.FC<ISearchBarOrderTableProps> = ({ remove, orders, dataTestId }) => {
  const onRemove = (event: MouseEvent<HTMLButtonElement>, fileNumber: string) => {
    remove?.(fileNumber);
    event.preventDefault();
  };
  const { data } = useGetSettingsQuery();
  const settings = data ?? { columns: defaultColumns };
  const userType = useGetUserType();

  return (
    <div data-test-id={dataTestId}>
      <div className={'flex flex-row gap-2 p-2 font-semibold'}>
        <div className={'flex flex-grow flex-row'}>
          {Object.values(ColumnDefinitions).map((column) => (
            <React.Fragment key={column.name}>{settings.columns.includes(column.name) && column.header}</React.Fragment>
          ))}
        </div>
        <div className={'basis-10'}></div>
        <div className={'basis-10'}></div>
      </div>
      {orders.map((order) => (
        <div
          key={order.id}
          data-test-id={`SearchBar-Order-${order.fileNumber}`}
          className={'flex flex-row gap-2 p-2 even:bg-slate-100 hover:bg-slate-200'}
        >
          <Link className={'flex flex-grow flex-row'} to={ClientUrlFactory().urlFor.orderPage(userType, order.id)}>
            {Object.values(ColumnDefinitions).map((column) => (
              <React.Fragment key={column.name}>
                {settings.columns.includes(column.name) && column.value(order)}
              </React.Fragment>
            ))}
          </Link>
          <a
            data-test-id={`SearchBar-Order-${order.fileNumber}-External-Link`}
            className={'flex basis-10 flex-row justify-center self-center'}
            href={ClientUrlFactory().urlFor.orderPage(userType, order.id)}
            target={'_blank'}
            rel="noreferrer"
          >
            <FontAwesomeIcon icon={faRightFromBracket} />
          </a>
          <div className={'basis-10 justify-center self-center'}>
            {remove && (
              <Button
                isInline
                intent={'ghost'}
                data-test-id={`Remove-SearchBar-Order-${order.fileNumber}`}
                onClick={(event) => onRemove(event, order.fileNumber.toString())}
              >
                <DangerText>
                  <FontAwesomeIcon icon={faRemove} />
                </DangerText>
              </Button>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};
